export default [
  {
    path: "/admin-dash",
    name: "admin-dash",
    component: () => import("@/views/admin/index.vue"),
  },
]